import { LINKS } from '@/shared/config/links';

export function LegalNote() {
  return (
    <p data-enter="" className="text-meta text-muted">
      By continuing you agree to the{' '}
      <a href={LINKS.TERMS} className="underline underline-offset-3">
        Terms
      </a>{' '}
      and the{' '}
      <a href={LINKS.PRIVACY} className="underline underline-offset-3">
        Privacy policy
      </a>
      .
    </p>
  );
}
